<div class="call-to-action-container">
    @if (displayAddToCart || isNoShadeOrNoSelect) {

    <h-call-to-action-add-to-cart (addToCart)="addToCartAction()" [addToCartError]="addToCartError" [positions]="[1]">
    </h-call-to-action-add-to-cart>

    } @else {

    <h-message-block [showBackground]="false" [type]="'info'">
        <ng-container i18n="@@hermes-availability.product-unavailable">
            Unfortunately this product is no longer available.
        </ng-container>
    </h-message-block>

    }
</div>
